import Cookies from 'universal-cookie';

export const ACTIVATION_DELAY_COOKIE_NAME = 'user_code_activation_delay';

export const setActivationDelayCookie = () => {
    const cookies = new Cookies();
    cookies.set(ACTIVATION_DELAY_COOKIE_NAME, 'true', {
        secure: true,
        sameSite: 'lax',
        maxAge: 60,
        path: '/',
    });
};
